const rootArea = "/geometries";

export const geometriesGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (configCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${configCode}/read`
	})
});